export enum DisclosurePath {
  Section = ':sectionId',
}
